module.exports = __webpack_public_path__ + "static/media/Toff.4564a23e.svg";